import DuckEntity from './DuckEntity';
import { arrayOf } from 'normalizr';
import { apiFetch, apiAction } from 'utils';
import { actionize } from 'utils';

export const fusionFormPages = new DuckEntity('fusionFormPages');

export const fusionFormTemplates = new DuckEntity('fusionFormTemplates', {
  schemaDefinition: {
    pages: arrayOf(fusionFormPages.schema)
  }
});

export const fusionForms = new DuckEntity('fusionForms', {
  apiPath: 'fusion_forms/forms',
  jsonRoot: 'form',
  jsonIndexRoot: 'forms',
  schemaDefinition: {
    template: fusionFormTemplates.schema
  }
});
